import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import styled from 'styled-components';
import { FormServFieldType } from '../../../shared/types';
import { ErrorField } from '../../../shared/styles';
import { getInputValue, setInputValue } from '../../utils';

type PhoneNumberInputProps = {
  field: FormServFieldType;
  form: UseFormReturn;
  isErrored?: boolean;
  errorText?: string;
  autoFocus?: boolean;
  limitMaxLength?: boolean;
};

const PhoneNumberInput = ({
  field,
  form,
  errorText,
  isErrored,
  autoFocus,
}: PhoneNumberInputProps) => {
  const { t } = useTranslation();
  const { label, type, name, placeholder = '', required } = field;
  const { watch, setValue } = form;

  const setFormValue = (fieldId: any, fieldValue: any) => {
    setValue(fieldId, fieldValue, {
      shouldValidate: true,
      shouldDirty: true,
      shouldTouch: true,
    });
  };

  return (
    <PhoneNumberInputContainer>
      <div className="label">
        {field.field_options?.fs_default
          ? `${t(`contacts.import_contact.default_fields.contact.${name}`)}`
          : label || ''}
        {required && <span className="required-phone">*</span>}
      </div>
      <PhoneInput
        className={`phone-number-input ${isErrored ? 'error' : ''}`.trim()}
        placeholder={placeholder}
        value={getInputValue(type, watch(name))}
        onChange={(val) => setFormValue(name, setInputValue(type, val))}
        limitMaxLength={true}
        autoFocus={autoFocus}
      />
      {isErrored && errorText && <ErrorField>{errorText}</ErrorField>}
    </PhoneNumberInputContainer>
  );
};

const PhoneNumberInputContainer = styled.div`
  div.label {
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #12344d;
    span.required-phone {
      color: var(--text-danger);
      font-weight: 700;
      font-size: 14px;
      margin-left: 2px;
    }
  }
  div.phone-number-input.error {
    border: 1px solid var(--text-danger);
  }
  div.phone-number-input {
    padding: 0 12px;
    border-radius: 5px;
    border: 1px solid #cfd7df;
    div.PhoneInputCountry {
      margin-right: 8px;
    }
    input {
      height: 34px;
      font-size: 14px;
      font-weight: 500;
    }
    input::placeholder {
      color: #92a2b1;
      font-size: 14px;
      font-weight: 500;
    }
  }
`;

export default PhoneNumberInput;
